module.exports = __webpack_public_path__ + "img/people-11.4df25046.png";